module.exports = __webpack_public_path__ + "img/lis2.e243a3dd.png";